module.exports = __webpack_public_path__ + "img/KinokoTable57.10aeb784.jpg";